<div class="video-round-container" [ngStyle]="{ '--round-size': ROUND_SIZE + 'px' }">
  <div class="video-round" (click)="url ? togglePlayPause() : loadRound()">
    <div class="video-round-status-wrapper">
      @if (remainingDuration || !isSound) {
        <div class="video-round-status">
          @if (remainingDuration) {
            <span>{{ remainingDuration | mediaSeconds }}</span>
          }
          @if (!isSound) {
            <app-icon class="icon-sm">no_sound</app-icon>
          }
        </div>
      }
      @if (isActive) {
        <app-button
          (onChangeClick)="$event.stopPropagation(); onVideoEnded()"
          class="video-round-stop-button"
          btnType="icon"
        >
          <app-icon>close</app-icon>
        </app-button>
      }
    </div>
    @if (!url) {
      @if (!isLoading) {
        <app-icon class="icon-lg">download</app-icon>
      }
      @if (isLoading) {
        <app-loader size="small" />
      }
    }
    @if (url) {
      <video
        #videoElement
        [src]="url"
        autoplay
        playsinline
        [loop]="!isActive"
        [muted]="!isSound"
        (ended)="onVideoEnded()"
      ></video>
      <div class="video-round-progress-ring">
        <svg [attr.viewBox]="'0 0 ' + ROUND_SIZE + ' ' + ROUND_SIZE" width="100%" height="100%">
          <circle
            [attr.cx]="ROUND_SIZE / 2"
            [attr.cy]="ROUND_SIZE / 2"
            [attr.r]="ROUND_SIZE / 2 - 2.5"
            stroke-width="5"
            stroke="blue"
            fill="none"
            [attr.stroke-dasharray]="2 * Math.PI * (ROUND_SIZE / 2 - 2.5)"
            [attr.stroke-dashoffset]="(1 - progress / 100) * (2 * Math.PI * (ROUND_SIZE / 2 - 2.5))"
          />
        </svg>
      </div>
    }
  </div>
</div>
